import TiposDeConveniosPage from "./TiposDeConveniosPage";
import { useDispatch, useSelector } from "react-redux";
import { getTiposDeConvenios } from "../../../selectors/administracao.selectors";
import { actions } from "../../../reducers/administracao/tiposDeConvenios.actions";
import { useCallback } from "react";
import { useForm } from "react-hook-form";
import validators from "../../../utils/validators";

const TiposDeConveniosPageConnected = () => {
  const dispatch = useDispatch();
  const tiposDeConvenios = useSelector(getTiposDeConvenios);
  const loading = tiposDeConvenios?.loading;
  const total = tiposDeConvenios?.total;
  const pagina = tiposDeConvenios?.page;

  const handlePagination = useCallback(
    (e, page) => {
      dispatch(actions.listarTiposDeConvenio.request({ pagina: page }));
    },
    [dispatch]
  );
  const handleEdit = useCallback(
    (values) => {
      dispatch(actions.editarTipoDeConvenio({ tipoDeConvenio: values }));
    },
    [dispatch]
  );
  const handleNew = useCallback(() => {
    dispatch(actions.novoTipoDeConvenio());
  }, [dispatch]);

  const handleDelete = useCallback(
    (i) => {
      dispatch(actions.excluirTipoDeConvenio.request({ idTipoDeConvenio: i }));
    },
    [dispatch]
  );

  const initialValues = {
    search: "",
  };

  const rules = {
    search: validators.string({ required: false }),
  };

  const formProps = {
    ...useForm(),
    rules,
    initialValues,
  };

  const handleSearch = useCallback(
    (values) => {
      const request = {
        by: "tipoConvenio",
        values: values.search,
      };
      dispatch(
        actions.buscarTipoDeConvenio.request({ search: request, pagina: 1 })
      );
    },
    [dispatch]
  );

  return (
    <TiposDeConveniosPage
      tiposDeConvenios={tiposDeConvenios.list}
      tipoDeConvenio={tiposDeConvenios.tipoDeConvenio}
      loading={loading}
      total={total}
      handlePagination={handlePagination}
      pagina={pagina}
      handleNew={handleNew}
      handleEdit={handleEdit}
      formProps={formProps}
      handleSearch={handleSearch}
      handleDelete={handleDelete}
    />
  );
};

export default TiposDeConveniosPageConnected;
